module.exports = __webpack_public_path__ + "img/logo-equipment.a1a32d31.webp";